import { Component, OnInit, OnDestroy } from '@angular/core';
import { PrType, ProductTypeService, PrTypeData } from '../../services/product-type.service';
import { Observable } from 'rxjs/Observable';
import { Ng2TableModule } from 'ng2-table/ng2-table';
import { Router } from '@angular/router';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-read-pr-c-type',
  templateUrl: './read-pr-c-type.component.html',
  styleUrls: ['./read-pr-c-type.component.css']
})
export class ReadPrCTypeComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};

  prTypes:any[] = [];

	datat:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Nombre', name: 'name',sort: 'asc'},
    {title: 'Descripción', name: 'description'},
    {title: 'Código', name: 'code'},
    {title: 'Reportar', name: 'report'},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit',
				styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete',
				styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  subs: Subscription[] = [];

  constructor(
    private service: ProductTypeService,
    private data: PrTypeData,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'prTypeC');
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else this.allowed = true;
    });

    this.subs.push(
      this.settings.getPayrollSettings('1').subscribe(setting => {
        this.itemsPerPage = setting.tableQuantity;
      })
    );
    this.subs.push(
      this.service.getPrCTypes().subscribe(tempPrTypes => {
        /* localStorage.prCTypes = JSON.stringify(tempPrTypes.reduce((acc, cur) => {
          acc[cur.name] = {id: cur.id, short: cur.code};
          return acc;
        }, {}) ); */
        this.prTypes = [];
        for (const idx in tempPrTypes) {
          const {report='key0', ...u} = tempPrTypes[idx];
          u.report = this.data.reports[report];
          this.prTypes.push(u);
        }

        if(localStorage.re_prcType__page){
          this.page = +localStorage.re_prcType__page;
        }
        this.datat = this.prTypes;
        this.length = this.datat.length;
        this.onChangeTable(this.config);
      })
    );
  }

  ngOnInit() {
    
  }
  ngOnDestroy(){
    this.subs.map((sub, index) => {
      this.subs[index].unsubscribe();
    })
  }

  deletePrType(sid: string) {
    this.service.deletePrType(sid);
  }

  onCellClick(data: any): any {
		//this.router.navigate(['/vw_employee/' + data.row.id$]);
		console.log('/vw_prType/' + data.row.id)
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.router.navigate(['/new_prTypeC']);
  }

	onEdit(data: any) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
		this.router.navigate(['/edit_prTypeC/', data.row.id]);
	}

	onDelete(data: any) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
		this.deletePrType(data.row.id);
  }
  
  /*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.datat):Array<any> {
		localStorage.re_prcType__page = `${page.page}`;
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.datat, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}
